interface CachedFetchRequests {
    [key: string]: null | Promise<Response>;
}

const catchedFetchRequests: CachedFetchRequests = {};

const cachedFetch = async (url: string, init?: RequestInit | undefined) => {
    if (catchedFetchRequests[url]) {
        return catchedFetchRequests[url] as Promise<Response>;
    }

    catchedFetchRequests[url] = fetch(url, init).then((res) => {
        delete catchedFetchRequests[url];
        return res;
    });

    return catchedFetchRequests[url] as Promise<Response>;
};

export default cachedFetch;
